import React from 'react'

const Shopware = () => (
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50.4378 56.9923C47.6909 54.8987 43.6396 53.3052 39.3526 51.6245C34.2497 49.624 28.4629 47.3501 24.1184 43.855C19.1994 39.8888 16.803 34.8874 16.803 28.5659C16.803 22.89 19.1304 18.0398 23.5323 14.533C28.4686 10.6017 35.9507 8.51976 45.1624 8.51976C47.7082 8.51976 50.139 8.67678 52.3917 8.99082C52.5928 9.0199 52.7824 8.9094 52.8629 8.72912C52.9491 8.54303 52.9031 8.32785 52.7537 8.19409C46.9496 2.90777 39.4446 0 31.6292 0C23.1817 0 15.24 3.32649 9.2635 9.37465C3.2928 15.417 0 23.4541 0 31.9971C0 40.5459 3.28705 48.583 9.2635 54.6253C15.2342 60.6677 23.176 64 31.6292 64C38.4562 64 44.9556 61.8308 50.4321 57.7309C50.547 57.6436 50.616 57.5099 50.616 57.3645C50.616 57.2191 50.5527 57.0795 50.4378 56.9923Z"
      fill="currentColor"
    />
    <path
      d="M64.3899 29.1204C64.3784 28.9983 64.3209 28.8819 64.229 28.8063C57.6319 23.2641 52.2933 21.0019 45.8054 21.0019C42.3459 21.0019 39.691 21.7056 37.9211 23.0897C36.3867 24.2877 35.5764 25.9625 35.5764 27.9224C35.5764 33.4181 42.2138 35.9246 49.9027 38.8265C53.8621 40.3211 57.9594 41.868 61.7177 43.9791C61.7867 44.0198 61.8614 44.0372 61.9361 44.0372C61.9878 44.0372 62.0395 44.0256 62.0912 44.0081C62.2119 43.9616 62.3153 43.8686 62.3613 43.7406C63.798 40.0187 64.5278 36.0932 64.5278 32.0747C64.522 31.1326 64.4818 30.1381 64.3899 29.1204Z"
      fill="currentColor"
    />
  </svg>
)

export default Shopware
